module.exports = __webpack_public_path__ + "static/img/scared.e8eba933.png";